import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TranslationEntity } from './translation.entity';

@Index('code-unique', ['code'], { unique: true })
@Entity('_translation_language')
export class TranslationLanguageEntity extends BaseEntity {
	@Column('varchar', { name: '_name', nullable: true, length: 255 })
	public name!: string | null;

	@Column('varchar', {
		name: '_code',
		nullable: true,
		unique: true,
		length: 32,
	})
	public code!: string | null;

	@Column('tinyint', {
		name: '_isActive',
		nullable: true,
		width: 1,
		default: () => "'0'",
	})
	public isActive!: boolean | null;

	@OneToMany(
		() => TranslationEntity,
		(translation) => translation.fkTranslationLanguage,
		{},
	)
	public translations!: Array<TranslationEntity>;
}
